import React from 'react';

type Props = {
  content: number | string;
};

export default function Badge({ content }: Props): JSX.Element {
  return <div className="badge">{content}</div>;
}
